const BASE = '/api/instructor';

function authHeaders() {
  const token = sessionStorage.getItem('af_token');
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

async function req(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  });
  const ct   = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : {};
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

/**
 * Upload a file directly to the backend (multipart).
 * fileType: 'video' | 'presentation' | 'resource'
 * onProgress: (pct: 0-100) => void
 */
export function uploadFile(courseId, moduleId, fileType, file, onProgress) {
  return new Promise((resolve, reject) => {
    const token = sessionStorage.getItem('af_token');
    const formData = new FormData();
    formData.append('file', file);

    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(Math.round(e.loaded / e.total * 100));
    };
    xhr.onload = () => {
      try {
        const json = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) resolve(json);
        else reject(new Error(json.error || 'Upload failed'));
      } catch { reject(new Error('Upload failed')); }
    };
    xhr.onerror = () => reject(new Error('Network error during upload'));
    xhr.open('POST', `/api/instructor/courses/${courseId}/modules/${moduleId}/upload/${fileType}`);
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.send(formData);
  });
}

export const getDashboard  = ()              => req('GET',    '/dashboard');
export const getCourses    = ()              => req('GET',    '/courses');
export const getCourse     = (id)            => req('GET',    `/courses/${id}`);
export const updateCourse  = (id, body)      => req('PATCH',  `/courses/${id}`, body);

export const createModule  = (cId, body)     => req('POST',   `/courses/${cId}/modules`, body);
export const getModule       = (cId, mId)      => req('GET',    `/courses/${cId}/modules/${mId}`);
export const updateModule  = (cId, mId, body)=> req('PATCH',  `/courses/${cId}/modules/${mId}`, body);

export const addQuestion    = (cId, mId, body)       => req('POST',   `/courses/${cId}/modules/${mId}/questions`, body);
export const updateQuestion = (cId, mId, qId, body)  => req('PATCH',  `/courses/${cId}/modules/${mId}/questions/${qId}`, body);
export const deleteQuestion = (cId, mId, qId)        => req('DELETE', `/courses/${cId}/modules/${mId}/questions/${qId}`);

export const addResource    = (cId, mId, body)        => req('POST',   `/courses/${cId}/modules/${mId}/resources`, body);
export const deleteResource    = (cId, mId, rId)          => req('DELETE', `/courses/${cId}/modules/${mId}/resources/${rId}`);
export const renameResource    = (cId, mId, rId, name)    => req('PATCH',  `/courses/${cId}/modules/${mId}/resources/${rId}`, { name });
export const addLinkResource   = (cId, mId, name, url)    => req('POST',   `/courses/${cId}/modules/${mId}/resources/link`, { name, url });

export const deleteVideo    = (cId, mId, vId)         => req('DELETE', `/courses/${cId}/modules/${mId}/videos/${vId}`);
export const renameVideo    = (cId, mId, vId, name)   => req('PATCH',  `/courses/${cId}/modules/${mId}/videos/${vId}`, { name });

export const getAssignments    = (cId)            => req('GET',   `/courses/${cId}/assignments`);
export const createAssignment  = (cId, body)      => req('POST',  `/courses/${cId}/assignments`, body);
export const updateAssignment  = (cId, aId, body) => req('PATCH', `/courses/${cId}/assignments/${aId}`, body);

export const getSubmissions  = (cId, aId)           => req('GET',   `/courses/${cId}/assignments/${aId}/submissions`);
export const gradeSubmission = (cId, aId, sId, body)=> req('PATCH', `/courses/${cId}/assignments/${aId}/submissions/${sId}`, body);

/** Trigger browser download of a student submission */
export async function downloadSubmission(cId, aId, sId, fileName) {
  const token = sessionStorage.getItem('af_token');
  const res = await fetch(`/api/instructor/courses/${cId}/assignments/${aId}/submissions/${sId}/download`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Download failed');
  }
  const blob = await res.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = fileName || 'submission';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const getStudents = (cId)       => req('GET', `/courses/${cId}/students`);
export const getStudent  = (cId, sId)  => req('GET', `/courses/${cId}/students/${sId}`);

export const getUploadSettings = () => req('GET', '/settings/upload');
